module.exports = __webpack_public_path__ + "img/114-127ca1.png";